import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, Compass } from "lucide-react";
import Footer from "@/Footer";

export const NotFound = () => (
  <div className="hi-bg hi-grain min-h-screen flex flex-col" data-testid="not-found">
    <div className="relative z-[2] flex-1 flex items-center justify-center px-5 py-20 text-center">
      <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}>
        <img src="/favicon.png" alt="Herrell Interactive" className="w-20 h-20 rounded-2xl mx-auto hi-float" />
        <p className="hi-serif hi-gold-text text-7xl md:text-8xl mt-8">404</p>
        <h1 className="hi-serif text-2xl md:text-3xl text-[#f3ead4] mt-2">This page wandered off the homestead</h1>
        <p className="hi-body text-white/70 mt-4 max-w-md mx-auto">
          The page you're looking for isn't here. Let's get you back to the apps.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3 mt-8">
          <Link to="/" data-testid="notfound-home" className="hi-cta inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-bold hi-body bg-[#c9a24b] text-[#1a2417] hover:bg-[#e0bb63]">
            <Home size={16} strokeWidth={2.5} /> Back to Home
          </Link>
          <Link to="/roadmap" className="hi-cta inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold hi-body bg-white/5 border border-white/10 text-white/85 hover:bg-white/10">
            <Compass size={16} strokeWidth={2.5} /> View Roadmap
          </Link>
        </div>
      </motion.div>
    </div>
    <div className="relative z-[2]"><Footer /></div>
  </div>
);

export default NotFound;
